(ns storrito.connect3.start-panel)

(defn panel
  [_]
  [:div.flex.flex-col.items-center

   [:div.leading-7.text-gray-900.sm:truncate.sm:tracking-tight.m-2
    "Select a proxy method:"]

   [:fieldset.flex.flex-col.items-center.justify-center.px-4.py-5.sm:p-6
    [:div.-space-y-px.rounded-md.bg-white.mb-6.flex.flex-col
     [:label.rounded-tl-md.rounded-tr-md.relative.border.p-4.flex.cursor-pointer.focus:outline-none

      [:span.ml-3.flex.flex-col
       {:on {:click [[:store/assoc-in
                      [:connect3 :status]
                      "connect-via-proxy"]]}}
       [:span#privacy-setting-0-label.block.text-xl.font-medium.font-bold
        "Use a Storrito proxy server (recommended)"]

       [:span#privacy-setting-0-description.block.text-sm
        "Connect your Instagram account via one of our proxy servers in a country of your choice"]]]

     ;; TODO: will be reactivated later for v2
     #_[:label.rounded-b-md.relative.border.p-4.flex.cursor-pointer.focus:outline-none
        [:input.mt-1.5.h-4.w-4.shrink-0.cursor-pointer.text-indigo-600.border-gray-300.focus:ring-indigo-500
         {:type "radio"
          :name "proxy-type"
          :value "connect-via-relay-app"
          :aria-labelledby "privacy-setting-1-label"
          :aria-describedby "privacy-setting-1-description"}]
        [:span.ml-3.flex.flex-col
         [:span#privacy-setting-1-label.block.text-xl.font-medium.font-bold
          "Use your own device (Relay app)"]
         [:span#privacy-setting-1-description.block.text-sm.max-w-lg
          "Connect your Instagram account through your own device."]]]


     [:label.rounded-tl-md.rounded-tr-md.relative.border.p-4.flex.cursor-pointer.focus:outline-none
      [:span.ml-3.flex.flex-col
       {:on {:click [[:store/assoc-in
                      [:connect3 :status]
                      "connect-via-private-proxy"]]}}
       [:span#privacy-setting-0-label.block.text-xl.font-medium.font-bold
        "Use your own proxy server"]

       [:span#privacy-setting-0-description.block.text-sm
        "Connect your Instagram account using your own proxy server"]]]

     ]]])
